module.exports = __webpack_public_path__ + "static/media/SFN2.c879530a.png";